import React, { Component } from 'react';
import * as styled from './magnify.styled';
import $ from 'jquery';
import {store} from '../../store';

class Magnify extends Component {

    constructor() {
        super();
        this.container = React.createRef();
        this.animating = false;
        this.state = {
            display: false
        };
    }

    componentDidCatch(){}

    componentDidMount() {
        $(document).on('scroll', this.closeMagnify.bind(this));
        store.display.onUpdate(() => {
            if (this.animating) return;
            this.animating = true;
            if (store.display.data.magnify) {
                this.setState((state) => {
                    return {...state, display: true};
                }, () => {
                    $(this.container.current).animate({opacity: 1}, 500, () => {
                        this.animating = false;
                    });
                });
            } else {
                if (this.state.display) {
                    $(this.container.current).animate({opacity: 0}, 500, (() => {
                        this.setState((state) => {
                            return {...state, display: false};
                        }, () => {
                            this.animating = false;
                        });
                    }).bind(this));
                } else {
                    this.animating = false;
                }
            }
        });
    }

    closeMagnify() {
        store.display.set({magnify: null});
    }

    render() {
        if (!this.state.display) return null;
        return (
            <styled.Container ref={this.container} onClick={this.closeMagnify.bind(this)}>
                <styled.Img src={store.display.data.magnify} />
            </styled.Container>
        );
    }
}

export default Magnify;